import { DBUserMessageThunks } from '@common-reducers/DBServiceThunks';
import type { AppThunkDispatch } from '@common/types/common-root-state-type';
import type { UserMessage } from '@bt-common/schemas/bt/user-message';
import type { FetchDocsById } from './lazy-thumbnail';

/** Full (non-lean) doc by id through the normal find thunk (#270). */
export const fetchUserMessageById = (dispatch: AppThunkDispatch): FetchDocsById => async (id) =>
    (await dispatch(DBUserMessageThunks.find({ _id: id, $paginate: false } as never)).unwrap()) as UserMessage[] | undefined;
